import { tKey } from 'ember-intl';
import { RESTRICTION_TYPES } from 'lumen/utils/constants/channel-pricing-constants';

function getRandomVariant(): number {
  return Math.floor(Math.random() * 3) + 1;
}

export function getRoomtypeAvailabilitytooltipReasonTranslation(
  restrictionType?: string,
  restrictionValue?: number,
): string | undefined {
  if (restrictionType === undefined || restrictionValue === undefined) {
    return undefined;
  }

  const variant = getRandomVariant();

  // Check if restriction recommendation is LOS2
  if (restrictionType === RESTRICTION_TYPES.MIN_LOS && restrictionValue === 2) {
    switch (variant) {
      case 1:
        return tKey(
          'channel_pricing.room_type_availability_tooltip.LOS_2_reason.1',
        );
      case 2:
        return tKey(
          'channel_pricing.room_type_availability_tooltip.LOS_2_reason.2',
        );
      default:
        return tKey(
          'channel_pricing.room_type_availability_tooltip.LOS_2_reason.3',
        );
    }
  }

  // Check if restriction recommendation is LOS3
  if (restrictionType === RESTRICTION_TYPES.MIN_LOS && restrictionValue === 3) {
    switch (variant) {
      case 1:
        return tKey(
          'channel_pricing.room_type_availability_tooltip.LOS_3_reason.1',
        );
      case 2:
        return tKey(
          'channel_pricing.room_type_availability_tooltip.LOS_3_reason.2',
        );
      default:
        return tKey(
          'channel_pricing.room_type_availability_tooltip.LOS_3_reason.3',
        );
    }
  }

  // Check if restriction recommendation is Open (CLOSED with value 0, or MIN_LOS with value 1)
  if (
    (restrictionType === RESTRICTION_TYPES.CLOSED && restrictionValue === 0) ||
    (restrictionType === RESTRICTION_TYPES.MIN_LOS && restrictionValue === 1)
  ) {
    switch (variant) {
      case 1:
        return tKey(
          'channel_pricing.room_type_availability_tooltip.open_reason.1',
        );
      case 2:
        return tKey(
          'channel_pricing.room_type_availability_tooltip.open_reason.2',
        );
      default:
        return tKey(
          'channel_pricing.room_type_availability_tooltip.open_reason.3',
        );
    }
  }

  return undefined;
}
